/* eslint-disable radix */
/* eslint-disable no-param-reassign */
import { parseISO, format } from 'date-fns'
import currency from 'currency.js'

export const INDICATOR_FORMAT_TYPE_ENUM = {
  CURRENCY: 1,
  PERCENTAGE: 2,
  INTEGER: 3,
  DECIMAL: 4,
  MULTIPLIER: 5,
  TEXT: 6,
  MILLIONS: 7,
  DATE: 8
}

export const formatPrice = (value, withoutPrefix) => {
  const options = {
    currency: 'BRL',
    minimumFractionDigits: 2
  }

  if (!withoutPrefix) {
    options.style = 'currency'
  }

  const formater = new Intl.NumberFormat('BRL', options)

  return formater.format(value).replace(/^(\D+)/, '$1 ')
}

export const formatToBr = (value) => {
  const parsed = parseISO(value)
  return format(parsed, 'dd/MM/yyyy')
}

const money = (value) =>
  currency(value, {
    symbol: '',
    separator: '.',
    decimal: ','
  })

export const formatIndicatorsValueForType = (value = '', type) => {
  if (!value) {
    value = 0
  }

  switch (type) {
    case INDICATOR_FORMAT_TYPE_ENUM.CURRENCY:
      return {
        formatted: money((value || 0).toString().replace('.', ',')).format(),
        value: (value || 0).toString().replace('.', ', '),
        prefix: 'R$ ',
        sufix: ''
      }

    case INDICATOR_FORMAT_TYPE_ENUM.DATE:
      return {
        formatted: formatToBr(value),
        value,
        prefix: '',
        sufix: ''
      }

    case INDICATOR_FORMAT_TYPE_ENUM.DECIMAL:
      return {
        formatted: parseFloat(value),
        value,
        prefix: '',
        sufix: ''
      }

    case INDICATOR_FORMAT_TYPE_ENUM.INTEGER:
      return {
        formatted: parseInt(value),
        value,
        prefix: '',
        sufix: ''
      }

    case INDICATOR_FORMAT_TYPE_ENUM.MILLIONS:
      return {
        formatted: value,
        value,
        prefix: '',
        sufix: ''
      }

    case INDICATOR_FORMAT_TYPE_ENUM.MULTIPLIER:
      return {
        formatted: value,
        value,
        prefix: '',
        sufix: ''
      }

    case INDICATOR_FORMAT_TYPE_ENUM.PERCENTAGE:
      return {
        formatted:
          value * 100
            ? (value * 100).toPrecision(4).replace('.', ',')
            : value * 100,
        value,
        prefix: '',
        sufix: ' %'
      }

    case INDICATOR_FORMAT_TYPE_ENUM.TEXT:
      return {
        formatted: value,
        value,
        prefix: '',
        sufix: ''
      }

    default:
      return {
        value,
        formatted: value,
        prefix: '',
        sufix: ''
      }
  }
}

export default { formatPrice }
